import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AffirmPayLaterComponent } from './affirm-pay-later.component';

@NgModule({
	imports: [CommonModule],
	declarations: [AffirmPayLaterComponent],
	exports: [AffirmPayLaterComponent]
})
export class AffirmPayLaterModule {}
